/* Tema design system lebih dulu, baru gaya paket bersama yang menumpang di atasnya. */
import "./styles.css"
import "@ramoo/self-order-ui/styles.css"
import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import { App } from "./App"
import { Privasi } from "./Privasi"

/* `/privasi/{kode outlet}` = formulir permintaan data pribadi (Modul 13 N6); selebihnya QR order. */
const [awal, kode] = window.location.pathname.split("/").filter(Boolean)

createRoot(document.getElementById("root") as HTMLElement).render(
  <StrictMode>
    {awal === "privasi" && kode ? <Privasi outletId={decodeURIComponent(kode)} /> : <App />}
  </StrictMode>,
)
